var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CustomPageHeaderVue',[_vm._v(_vm._s(_vm.$t("nav_about")))]),_c('CustomRow',[_c('v-card',{staticClass:"mt-5 cusPadding text-center",domProps:{"innerHTML":_vm._s(_vm.$t('about_content'))}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }